import fetch from 'isomorphic-fetch';

const methods = [
  'get',
  'post',
  'put',
  'delete',
];

export default class fetchWP {
  constructor( options = {} ) {
    this.options = options;
    
    if ( !options.restURL )
    throw new Error('restURL option is required');
    
    methods.forEach(method => {
      this[method] = this._setup(method);
    });
  }
  
  _setup( method ) {
      return (endpoint = '/', data = false) => {

          let fetchObject = {
              credentials: 'same-origin',
              method: method,
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'cookie': '_gcl_au = 1.1.1354668601.1656178795; cmplz_choice=set; cmplz_policy_id=14; cmplz_functional=allow; cmplz_statistics- anonymous=allow; _ga=GA1.2.1524845275.1656178795; _gid=GA1.2.423841362.1656178795; _gat_gtag_UA_92392669_1=1; _pin_unauth=dWlkPU16ZzNNR0ZrWTJJdFltRTVOQzAwT0dKaUxXSm1ZVFV0TW1Sak5EazJZMlJrTlRCaQ; cmplz_preferences=allow; cmplz_marketing=allow; cmplz_event_0=deny; cmplz_consent_status=allow; _fbp=fb.1.1656178797288.27880538'
              }
          };

          if (this.options.restNonce) {
              if (this.options.restNonce !== "https://lucksmith.de") {
                  fetchObject = {
                      credentials: 'same-origin',
                      method: method,
                      headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'X-WP-Nonce': this.options.restNonce,
                      }
                  };
              }
          }
      
      if ( data ) {
        fetchObject.body = JSON.stringify(data);
      }
      
      return fetch(this.options.restURL + endpoint, fetchObject)
      .then(response => {
        return response.json().then(json => {
          return response.ok ? json : Promise.reject(json);
        });
      });
    }
  }
}